import { render, staticRenderFns } from "./dialog-remark.vue?vue&type=template&id=c60a2878"
import script from "./dialog-remark.vue?vue&type=script&lang=js"
export * from "./dialog-remark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports